import axiosInstance from "../helpers/axiosInstance"

const BASE = process.env.REACT_APP_PLATFORM_URL

// Shipping Methods
export const fetchLastmileShippingMethods = async (params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/shipping-methods`, { params })
    return res.data
}

export const updateLastmileShippingMethod = async (id, data) => {
    const res = await axiosInstance.put(`${BASE}/api/v1/lastmile/shipping-methods/${id}`, data)
    return res.data
}

export const fetchShippingMethodHistory = async (id, params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/shipping-methods/${id}/history`, { params })
    return res.data
}

// Dispatch Schedules
export const fetchDispatchSchedules = async (params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules`, { params })
    return res.data
}

export const createDispatchSchedule = async (data) => {
    const res = await axiosInstance.post(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules`, data)
    return res.data
}

export const updateDispatchSchedule = async (id, data) => {
    const res = await axiosInstance.put(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules/${id}`, data)
    return res.data
}

export const deleteDispatchSchedule = async (id) => {
    const res = await axiosInstance.delete(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules/${id}`)
    return res.data
}

export const fetchDispatchScheduleHistory = async (id, params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules/${id}/history`, { params })
    return res.data
}

// Available States (for dispatch schedule filtering by destination state)
export const fetchAvailableStates = async (params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules/available-states`, { params })
    return res.data
}

// Shared
export const fetchCarrierNames = async () => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/carrier-names`)
    return res.data
}

export const fetchAvailableChannelTypes = async (params) => {
    const res = await axiosInstance.get(`${BASE}/api/v1/lastmile/warehouse-dispatch-schedules/available-channel-types`, { params })
    return res.data
}
